import { render, staticRenderFns } from "./Select2.vue?vue&type=template&id=ff5b0328&"
import script from "./Select2.vue?vue&type=script&lang=js&"
export * from "./Select2.vue?vue&type=script&lang=js&"
import style0 from "./Select2.vue?vue&type=style&index=0&id=ff5b0328&prod&scope=true&lang=css&"
import style1 from "./Select2.vue?vue&type=style&index=1&id=ff5b0328&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports